import React, { useState, useEffect } from "react";
import { useQuery } from 'react-query';
import { getDownloadURL, uploadBytesResumable } from "firebase/storage";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { auth, storage } from "../../../firebase";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function DealerInfo ({ logoName }) {

    const id = 'KD6FHhBRkM5ISPT8qTRZ';

    const [dealerName, setDealerName] = useState("");
    const [dealerGemi, setDealerGemi] = useState("");
    const [dealerInfoText, setDealerInfoText] = useState("");

    // 1st Ypokatastima
    const [dealerEkthesiName, setDealerEkthesiName] = useState("");
    const [dealerAddress, setDealerAddress] = useState("");
    const [dealerEmail, setDealerEmail] = useState("");
    const [dealerPhone, setDealerPhone] = useState("");
    const [dealerMonday, setDealerMonday] = useState("");
    const [dealerTuesday, setDealerTuesday] = useState("");
    const [dealerWednesday, setDealerWednesday] = useState("");
    const [dealerThursday, setDealerThursday] = useState("");
    const [dealerFriday, setDealerFriday] = useState("");
    const [dealerSaturday, setDealerSaturday] = useState("");

    // 2nd Ypokatastima
    const [dealerEkthesiNameB, setDealerEkthesiNameB] = useState("");
    const [dealerAddressB, setDealerAddressB] = useState(" ");
    const [dealerEmailB, setDealerEmailB] = useState(" ");
    const [dealerPhoneB, setDealerPhoneB] = useState(" ");
    const [dealerMondayB, setDealerMondayB] = useState(" ");
    const [dealerTuesdayB, setDealerTuesdayB] = useState(" ");
    const [dealerWednesdayB, setDealerWednesdayB] = useState(" ");
    const [dealerThursdayB, setDealerThursdayB] = useState(" ");
    const [dealerFridayB, setDealerFridayB] = useState(" ");
    const [dealerSaturdayB, setDealerSaturdayB] = useState(" ");

    // 3rd Ypokatastima
    const [dealerEkthesiNameC, setDealerEkthesiNameC] = useState("");
    const [dealerAddressC, setDealerAddressC] = useState(" ");
    const [dealerEmailC, setDealerEmailC] = useState(" ");
    const [dealerPhoneC, setDealerPhoneC] = useState(" ");
    const [dealerMondayC, setDealerMondayC] = useState(" ");
    const [dealerTuesdayC, setDealerTuesdayC] = useState(" ");
    const [dealerWednesdayC, setDealerWednesdayC] = useState(" ");
    const [dealerThursdayC, setDealerThursdayC] = useState(" ");
    const [dealerFridayC, setDealerFridayC] = useState(" ");
    const [dealerSaturdayC, setDealerSaturdayC] = useState(" ");

    // 4th Ypokatastima
    const [dealerEkthesiNameD, setDealerEkthesiNameD] = useState("");
    const [dealerAddressD, setDealerAddressD] = useState(" ");
    const [dealerEmailD, setDealerEmailD] = useState(" ");
    const [dealerPhoneD, setDealerPhoneD] = useState(" ");
    const [dealerMondayD, setDealerMondayD] = useState(" ");
    const [dealerTuesdayD, setDealerTuesdayD] = useState(" ");
    const [dealerWednesdayD, setDealerWednesdayD] = useState(" ");
    const [dealerThursdayD, setDealerThursdayD] = useState(" ");
    const [dealerFridayD, setDealerFridayD] = useState(" ");
    const [dealerSaturdayD, setDealerSaturdayD] = useState(" ");

    // 5th Ypokatastima
    const [dealerEkthesiNameE, setDealerEkthesiNameE] = useState("");
    const [dealerAddressE, setDealerAddressE] = useState(" ");
    const [dealerEmailE, setDealerEmailE] = useState(" ");
    const [dealerPhoneE, setDealerPhoneE] = useState(" ");
    const [dealerMondayE, setDealerMondayE] = useState(" ");
    const [dealerTuesdayE, setDealerTuesdayE] = useState(" ");
    const [dealerWednesdayE, setDealerWednesdayE] = useState(" ");
    const [dealerThursdayE, setDealerThursdayE] = useState(" ");
    const [dealerFridayE, setDealerFridayE] = useState(" ");
    const [dealerSaturdayE, setDealerSaturdayE] = useState(" ");

    useEffect(() => {
        const fetchData = async () => {
          const docRef = firebase.firestore().collection("dealerInfo").doc(id);
          const doc = await docRef.get();
          
          if (doc.exists) {
            const data = doc.data();
            setDealerName(data.dealerName);
            setDealerGemi(data.dealerGemi);
            setDealerInfoText(data.dealerInfoText);

            setDealerEkthesiName(data.dealerEkthesiName);
            setDealerAddress(data.dealerAddress);
            setDealerEmail(data.dealerEmail);
            setDealerPhone(data.dealerPhone);
            setDealerMonday(data.dealerMonday);
            setDealerTuesday(data.dealerTuesday);
            setDealerWednesday(data.dealerWednesday);
            setDealerThursday(data.dealerThursday);
            setDealerFriday(data.dealerFriday);
            setDealerSaturday(data.dealerSaturday);
            
            setDealerEkthesiNameB(data.dealerEkthesiNameB);
            setDealerAddressB(data.dealerAddressB);
            setDealerEmailB(data.dealerEmailB);
            setDealerPhoneB(data.dealerPhoneB);
            setDealerMondayB(data.dealerMondayB);
            setDealerTuesdayB(data.dealerTuesdayB);
            setDealerWednesdayB(data.dealerWednesdayB);
            setDealerThursdayB(data.dealerThursdayB);
            setDealerFridayB(data.dealerFridayB);
            setDealerSaturdayB(data.dealerSaturdayB);

            setDealerEkthesiNameC(data.dealerEkthesiNameC);
            setDealerAddressC(data.dealerAddressC);
            setDealerEmailC(data.dealerEmailC);
            setDealerPhoneC(data.dealerPhoneC);
            setDealerMondayC(data.dealerMondayC);
            setDealerTuesdayC(data.dealerTuesdayC);
            setDealerWednesdayC(data.dealerWednesdayC);
            setDealerThursdayC(data.dealerThursdayC);
            setDealerFridayC(data.dealerFridayC);
            setDealerSaturdayC(data.dealerSaturdayC);

            setDealerEkthesiNameD(data.dealerEkthesiNameD);
            setDealerAddressD(data.dealerAddressD);
            setDealerEmailD(data.dealerEmailD);
            setDealerPhoneD(data.dealerPhoneD);
            setDealerMondayD(data.dealerMondayD);
            setDealerTuesdayD(data.dealerTuesdayD);
            setDealerWednesdayD(data.dealerWednesdayD);
            setDealerThursdayD(data.dealerThursdayD);
            setDealerFridayD(data.dealerFridayD);
            setDealerSaturdayD(data.dealerSaturdayD);

            setDealerEkthesiNameE(data.dealerEkthesiNameE);
            setDealerAddressE(data.dealerAddressE);
            setDealerEmailE(data.dealerEmailE);
            setDealerPhoneE(data.dealerPhoneE);
            setDealerMondayE(data.dealerMondayE);
            setDealerTuesdayE(data.dealerTuesdayE);
            setDealerWednesdayE(data.dealerWednesdayE);
            setDealerThursdayE(data.dealerThursdayE);
            setDealerFridayE(data.dealerFridayE);
            setDealerSaturdayE(data.dealerSaturdayE);
          } else {
            console.log("Document not found");
          }
        };
        
        fetchData();
    }, [id]);

    // Updating data in Firestore
    const handleSliderInfoSubmit = (event) => {
        event.preventDefault();
        
        const data = {
            dealerName: dealerName,
            dealerGemi: dealerGemi,
            dealerInfoText: dealerInfoText,

            dealerEkthesiName: dealerEkthesiName,
            dealerAddress: dealerAddress,
            dealerEmail: dealerEmail,
            dealerPhone: dealerPhone,
            dealerMonday: dealerMonday,
            dealerTuesday: dealerTuesday,
            dealerWednesday: dealerWednesday,
            dealerThursday: dealerThursday,
            dealerFriday: dealerFriday,
            dealerSaturday: dealerSaturday,

            dealerEkthesiNameB: dealerEkthesiNameB,
            dealerAddressB: dealerAddressB,
            dealerEmailB: dealerEmailB,
            dealerPhoneB: dealerPhoneB,
            dealerMondayB: dealerMondayB,
            dealerTuesdayB: dealerTuesdayB,
            dealerWednesdayB: dealerWednesdayB,
            dealerThursdayB: dealerThursdayB,
            dealerFridayB: dealerFridayB,
            dealerSaturdayB: dealerSaturdayB,

            dealerEkthesiNameC: dealerEkthesiNameC,
            dealerAddressC: dealerAddressC,
            dealerEmailC: dealerEmailC,
            dealerPhoneC: dealerPhoneC,
            dealerMondayC: dealerMondayC,
            dealerTuesdayC: dealerTuesdayC,
            dealerWednesdayC: dealerWednesdayC,
            dealerThursdayC: dealerThursdayC,
            dealerFridayC: dealerFridayC,
            dealerSaturdayC: dealerSaturdayC,

            dealerEkthesiNameD: dealerEkthesiNameD,
            dealerAddressD: dealerAddressD,
            dealerEmailD: dealerEmailD,
            dealerPhoneD: dealerPhoneD,
            dealerMondayD: dealerMondayD,
            dealerTuesdayD: dealerTuesdayD,
            dealerWednesdayD: dealerWednesdayD,
            dealerThursdayD: dealerThursdayD,
            dealerFridayD: dealerFridayD,
            dealerSaturdayD: dealerSaturdayD,

            dealerEkthesiNameE: dealerEkthesiNameE,
            dealerAddressE: dealerAddressE,
            dealerEmailE: dealerEmailE,
            dealerPhoneE: dealerPhoneE,
            dealerMondayE: dealerMondayE,
            dealerTuesdayE: dealerTuesdayE,
            dealerWednesdayE: dealerWednesdayE,
            dealerThursdayE: dealerThursdayE,
            dealerFridayE: dealerFridayE,
            dealerSaturdayE: dealerSaturdayE,
        };

        const toastSubmission = toast.loading("Παρακαλώ περιμένετε...", { position: toast.POSITION.BOTTOM_RIGHT});
        
        firebase.firestore().collection("dealerInfo").doc(id).update(data).then(() => {
            // alert("Document updated successfully");
            toast.update(toastSubmission, { render: "Επιτυχής ενημέρωση", type: "success", autoClose: 5000, hideProgressBar: false, isLoading: false, position: toast.POSITION.BOTTOM_RIGHT });
        }).catch((error) => {
            alert("Error updating document: " + error.message);
        });
    };

    // Fetch stored slider image
    const { data: logoImageUrl, refetch } = useQuery(
        ['logo', logoName],
        async () => {
          const storageRef = storage.ref(`files/logo`);
          const url = await storageRef.getDownloadURL();
          return url;
        },
        { enabled: true } // disable automatic fetching
    );

    // Upload new slider image
    const [logoUrl, setLogoUrl] = useState(null);
    const [progressLogoPercent, setProgressLogoPercent] = useState(0);

    const handleLogoSubmit = (e) => {
        e.preventDefault()
        const file = e.target[0]?.files[0]
        if (!file) return;

        const storageRef = storage.ref(`files/logo`);
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on("state_changed",
            (snapshot) => {
                const progressLogo =
                Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                setProgressLogoPercent(progressLogo);
            },
            (error) => {
                alert(error);
            },
            () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                setLogoUrl(downloadURL);
                // Refetch slider image on success
                refetch();
                });
            }
        );
    }

    return (
        <div className='container equal-heights-container padding-vert-40'>
            <div className="title-container fs-3vw fw-900 blue vertical">
                Dealer Info
            </div>
            <div className="content-container border-left-blue padding-left-20">
            <div className="row">
                    <div className="col s12">
                        {logoImageUrl && (
                            <img src={logoImageUrl} alt={`Image ${logoName}`} className='max-width-100' />
                        )}
                        {
                            !logoUrl &&
                            <div className='outerbar'>
                            <div className='innerbar' style={{ width: `${progressLogoPercent}%` }}>{progressLogoPercent}%</div>
                            </div>
                        }
                    </div>
                </div>
                <div  className='dashboard-form'>

                <form onSubmit={handleLogoSubmit}>
                    <div className="row">
                        <div className="col s12">
                            <input type='file' accept='image/png, image/jpeg'/>
                            <div className='col s12 ta-center padding-vert-10'>
                                <button type='submit'>Upload</button>
                            </div>
                        </div>
                    </div>
                </form>

                    <form onSubmit={handleSliderInfoSubmit}>
                        <div className="row">
                            <div className="col m8 s12">
                                <p className='form-label blue'>Oνομασία Dealer</p>
                                <input type="text" value={dealerName} onChange={(event) => setDealerName(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Αριθμός Γ.Ε.Μ.Η.</p>
                                <input type="text" value={dealerGemi} onChange={(event) => setDealerGemi(event.target.value)} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col s12">
                                <p className='form-label blue'>Πληροφορίες Dealer</p>
                                <ReactQuill theme="snow" value={dealerInfoText} onChange={setDealerInfoText} />
                            </div>
                        </div>
    
                        <div className="row">
                            <div className="col s12">
                                <div className="fs-2vw fw-900 blue ta-center">1o Κατάστημα</div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col m6 s12">
                                <p className='form-label blue'>Ονομασία Dealer #1</p>
                                <input type="text" value={dealerEkthesiName} onChange={(event) => setDealerEkthesiName(event.target.value)} />
                            </div>
                            <div className="col m6 s12">
                                <p className='form-label blue'>Διεύθυνση Dealer #1</p>
                                <input type="text" value={dealerAddress} onChange={(event) => setDealerAddress(event.target.value)} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col m6 s12">
                                <p className='form-label blue'>Email Dealer #1</p>
                                <input type="text" value={dealerEmail} onChange={(event) => setDealerEmail(event.target.value)} />
                            </div>
                            <div className="col m6 s12">
                                <p className='form-label blue'>Τηλέφωνο Dealer #1</p>
                                <input type="text" value={dealerPhone} onChange={(event) => setDealerPhone(event.target.value)} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Δευτέρας #1</p>
                                <input type="text" value={dealerMonday} onChange={(event) => setDealerMonday(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Τρίτης #1</p>
                                <input type="text" value={dealerTuesday} onChange={(event) => setDealerTuesday(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Τετάρτης #1</p>
                                <input type="text" value={dealerWednesday} onChange={(event) => setDealerWednesday(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Πέμπτης #1</p>
                                <input type="text" value={dealerThursday} onChange={(event) => setDealerThursday(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Παρασκευής #1</p>
                                <input type="text" value={dealerFriday} onChange={(event) => setDealerFriday(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Σαββάτου #1</p>
                                <input type="text" value={dealerSaturday} onChange={(event) => setDealerSaturday(event.target.value)} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col s12">
                                <div className="fs-2vw fw-900 blue ta-center">2o Κατάστημα</div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col m6 s12">
                                <p className='form-label blue'>Ονομασία Dealer #2</p>
                                <input type="text" value={dealerEkthesiNameB} onChange={(event) => setDealerEkthesiNameB(event.target.value)} />
                            </div>
                            <div className="col m6 s12">
                                <p className='form-label blue'>Διεύθυνση Dealer #2</p>
                                <input type="text" value={dealerAddressB} onChange={(event) => setDealerAddressB(event.target.value)} />
                            </div>
                        </div>
                        
                        <div className="row">
                            <div className="col m6 s12">
                                <p className='form-label blue'>Email Dealer #2</p>
                                <input type="text" value={dealerEmailB} onChange={(event) => setDealerEmailB(event.target.value)} />
                            </div>
                            <div className="col m6 s12">
                                <p className='form-label blue'>Τηλέφωνο Dealer #2</p>
                                <input type="text" value={dealerPhoneB} onChange={(event) => setDealerPhoneB(event.target.value)} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Δευτέρας #2</p>
                                <input type="text" value={dealerMondayB} onChange={(event) => setDealerMondayB(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Τρίτης #2</p>
                                <input type="text" value={dealerTuesdayB} onChange={(event) => setDealerTuesdayB(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Τετάρτης #2</p>
                                <input type="text" value={dealerWednesdayB} onChange={(event) => setDealerWednesdayB(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Πέμπτης #2</p>
                                <input type="text" value={dealerThursdayB} onChange={(event) => setDealerThursdayB(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Παρασκευής #2</p>
                                <input type="text" value={dealerFridayB} onChange={(event) => setDealerFridayB(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Σαββάτου #2</p>
                                <input type="text" value={dealerSaturdayB} onChange={(event) => setDealerSaturdayB(event.target.value)} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col s12">
                                <div className="fs-2vw fw-900 blue ta-center">3o Κατάστημα</div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col m6 s12">
                                <p className='form-label blue'>Ονομασία Dealer #3</p>
                                <input type="text" value={dealerEkthesiNameC} onChange={(event) => setDealerEkthesiNameC(event.target.value)} />
                            </div>
                            <div className="col m6 s12">
                                <p className='form-label blue'>Διεύθυνση Dealer #3</p>
                                <input type="text" value={dealerAddressC} onChange={(event) => setDealerAddressC(event.target.value)} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col m6 s12">
                                <p className='form-label blue'>Email Dealer #3</p>
                                <input type="text" value={dealerEmailC} onChange={(event) => setDealerEmailC(event.target.value)} />
                            </div>
                            <div className="col m6 s12">
                                <p className='form-label blue'>Τηλέφωνο Dealer #3</p>
                                <input type="text" value={dealerPhoneC} onChange={(event) => setDealerPhoneC(event.target.value)} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Δευτέρας #3</p>
                                <input type="text" value={dealerMondayC} onChange={(event) => setDealerMondayC(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Τρίτης #3</p>
                                <input type="text" value={dealerTuesdayC} onChange={(event) => setDealerTuesdayC(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Τετάρτης #3</p>
                                <input type="text" value={dealerWednesdayC} onChange={(event) => setDealerWednesdayC(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Πέμπτης #3</p>
                                <input type="text" value={dealerThursdayC} onChange={(event) => setDealerThursdayC(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Παρασκευής #3</p>
                                <input type="text" value={dealerFridayC} onChange={(event) => setDealerFridayC(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Σαββάτου #3</p>
                                <input type="text" value={dealerSaturdayC} onChange={(event) => setDealerSaturdayC(event.target.value)} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col s12">
                                <div className="fs-2vw fw-900 blue ta-center">4o Κατάστημα</div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col m6 s12">
                                <p className='form-label blue'>Ονομασία Dealer #4</p>
                                <input type="text" value={dealerEkthesiNameD} onChange={(event) => setDealerEkthesiNameD(event.target.value)} />
                            </div>
                            <div className="col m6 s12">
                                <p className='form-label blue'>Διεύθυνση Dealer #4</p>
                                <input type="text" value={dealerAddressD} onChange={(event) => setDealerAddressD(event.target.value)} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col m6 s12">
                                <p className='form-label blue'>Email Dealer #4</p>
                                <input type="text" value={dealerEmailD} onChange={(event) => setDealerEmailD(event.target.value)} />
                            </div>
                            <div className="col m6 s12">
                                <p className='form-label blue'>Τηλέφωνο Dealer #4</p>
                                <input type="text" value={dealerPhoneD} onChange={(event) => setDealerPhoneD(event.target.value)} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Δευτέρας #4</p>
                                <input type="text" value={dealerMondayD} onChange={(event) => setDealerMondayD(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Τρίτης #4</p>
                                <input type="text" value={dealerTuesdayD} onChange={(event) => setDealerTuesdayD(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Τετάρτης #4</p>
                                <input type="text" value={dealerWednesdayD} onChange={(event) => setDealerWednesdayD(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Πέμπτης #4</p>
                                <input type="text" value={dealerThursdayD} onChange={(event) => setDealerThursdayD(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Παρασκευής #4</p>
                                <input type="text" value={dealerFridayD} onChange={(event) => setDealerFridayD(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Σαββάτου #4</p>
                                <input type="text" value={dealerSaturdayD} onChange={(event) => setDealerSaturdayD(event.target.value)} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col s12">
                                <div className="fs-2vw fw-900 blue ta-center">5o Κατάστημα</div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col m6 s12">
                                <p className='form-label blue'>Ονομασία Dealer #5</p>
                                <input type="text" value={dealerEkthesiNameE} onChange={(event) => setDealerEkthesiNameE(event.target.value)} />
                            </div>
                            <div className="col m6 s12">
                                <p className='form-label blue'>Διεύθυνση Dealer #5</p>
                                <input type="text" value={dealerAddressE} onChange={(event) => setDealerAddressE(event.target.value)} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col m6 s12">
                                <p className='form-label blue'>Email Dealer #5</p>
                                <input type="text" value={dealerEmailE} onChange={(event) => setDealerEmailE(event.target.value)} />
                            </div>
                            <div className="col m6 s12">
                                <p className='form-label blue'>Τηλέφωνο Dealer #5</p>
                                <input type="text" value={dealerPhoneE} onChange={(event) => setDealerPhoneE(event.target.value)} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Δευτέρας #5</p>
                                <input type="text" value={dealerMondayE} onChange={(event) => setDealerMondayE(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Τρίτης #5</p>
                                <input type="text" value={dealerTuesdayE} onChange={(event) => setDealerTuesdayE(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Τετάρτης #5</p>
                                <input type="text" value={dealerWednesdayE} onChange={(event) => setDealerWednesdayE(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Πέμπτης #5</p>
                                <input type="text" value={dealerThursdayE} onChange={(event) => setDealerThursdayE(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Παρασκευής #5</p>
                                <input type="text" value={dealerFridayE} onChange={(event) => setDealerFridayE(event.target.value)} />
                            </div>
                            <div className="col m4 s12">
                                <p className='form-label blue'>Ωράριο Σαββάτου #5</p>
                                <input type="text" value={dealerSaturdayE} onChange={(event) => setDealerSaturdayE(event.target.value)} />
                            </div>
                        </div>

                        <div className="row">
                            <div className='col s12 ta-center padding-vert-10'>
                                <button type="submit">Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
                <ToastContainer autoClose={5000} />
            </div>
        </div>
      );
    }
export default DealerInfo;
